import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20e27d00&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=20e27d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e27d00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CollectionBox: require('/drone/src/components/CollectionBox/index.vue').default})
